import { render } from "./ChatGroupView.vue?vue&type=template&id=72f27004&scoped=true"
import script from "./ChatGroupView.vue?vue&type=script&lang=js"
export * from "./ChatGroupView.vue?vue&type=script&lang=js"

import "./ChatGroupView.vue?vue&type=style&index=0&id=72f27004&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f27004"]])

export default __exports__